import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-4" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexHydromet',
  setup(__props) {

const HydrometInsMonitor = defineAsyncComponent(() => import("@/components/theme/stations/hydromet/HydrometInsMonitor.vue"))
const HydrometTempCard = defineAsyncComponent(() => import("@/components/theme/stations/hydromet/HydrometTempCard.vue"))
const HydrometStatistics = defineAsyncComponent(() => import("@/components/theme/stations/hydromet/HydrometStatistics.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(HydrometInsMonitor)),
      _createVNode(_unref(HydrometStatistics)),
      _createVNode(_unref(HydrometTempCard))
    ])
  ]))
}
}

})